import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { injectIntl } from 'react-intl';

import { connectUser } from '../actions/Auth';

import Loading from '../components/Loading';

class Connect extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      redirect: null,
      accessTokenUuid: null,
      error: false,
    };
  }

  componentDidMount() {
    this.initState();
  }

  initState() {
    const { location } = this.props;
    const urlParams = new URLSearchParams(location.search);
    if (!(urlParams.get('redirect') && urlParams.get('access_token'))) {
      this.setState({ error: true });
    } else {
      this.setState({
        redirect: urlParams.get('redirect'),
        accessTokenUuid: urlParams.get('access_token'),
      }, () => this.connect());
    }
  }

  connect() {
    const { connectUserAction } = this.props;
    const {
      redirect,
      accessTokenUuid,
    } = this.state;

    connectUserAction(accessTokenUuid)
      .then((response) => {
        if (response.error || response.errors) {
          this.setState({ error: true });
        } else {
          const redirectUrl = queryString.parseUrl(redirect);
          redirectUrl.query = {
            ...redirectUrl.query,
            stockpress_user: response.uuid,
            stockpress_user_token: response.login_token,
          };
          const rurl = `${redirectUrl.url}?${queryString.stringify(redirectUrl.query)}`;
          window.location = rurl;
        }
      })
      .catch(() => {
        this.setState({ error: true });
      });
  }

  render() {
    const { intl } = this.props;
    const { error } = this.state;

    return (
      <div className="connect-wrapper">
        {error ? (
          <Fragment>
            <h3>{intl.formatMessage({ defaultMessage: 'Something went wrong' })}</h3>
            <p>{intl.formatMessage({ defaultMessage: 'Please go back and try again' })}</p>
          </Fragment>
        ) : (
          <Fragment>
            <h3>{intl.formatMessage({ defaultMessage: 'Connecting...' })}</h3>
            <Loading />
          </Fragment>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  connectUserAction: accessTokenUuid => (
    dispatch(connectUser({ access_token: accessTokenUuid }))
  ),
});

Connect.propTypes = {
  intl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  connectUserAction: PropTypes.func.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(Connect)));
